import { useState } from "react";
import "./CreditCardForm.css";

/* global PGUtils, PGDigitalWalletsIntent, PGDataType */

function WithdrawalDigitalWalletForm({
  onSubmit,
  userDigitalWallets,
  selectedPaymentOption
}) {
  const [walletData, setWalletData] = useState({
    wallet: (userDigitalWallets && userDigitalWallets[0]) || null
  });

  const handleWalletDataChange = (e) => {
    const { name, value } = e.target;
    setWalletData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmitWallet = async (e) => {
    e.preventDefault();

    console.log("Form submitted with wallet:", walletData);
    if (typeof onSubmit === "function") {
      await onSubmit(walletData);
    }
  };

  // Filter wallets by:
  // 1. Withdrawal intent (intent & 2 === 2) - required
  // 2. Provider ID must match payment option's providerId - VERY IMPORTANT
  // 3. DataType must match wallet's executedMethod (if available)
  //    - ApplePay (dataType) -> executedMethod === 4
  //    - GooglePay (dataType) -> executedMethod === 3
  const filteredWallets = userDigitalWallets
    ? userDigitalWallets.filter((wallet) => {
        // 1. Check if wallet has withdrawal intent using SDK helper
        // PGUtils and PGDigitalWalletsIntent are global when SDK is loaded
        // eslint-disable-next-line no-undef
        if (
          !PGUtils?.hasFlag(wallet.intent, PGDigitalWalletsIntent?.Withdrawal)
        ) {
          return false;
        }

        // 2. Filter by provider ID - MUST match (very important)
        const paymentOptionProviderId =
          selectedPaymentOption?.initParams?.providerId;
        if (paymentOptionProviderId) {
          // ProviderId is specified - wallet must match exactly
          if (wallet.providerId !== paymentOptionProviderId) {
            return false;
          }
        }
        // Note: If providerId is not specified in payment option,
        // we show all wallets with withdrawal intent (backend will validate)

        // 3. Filter by dataType matching executedMethod (if available)
        const dataType = selectedPaymentOption?.dataType;
        // eslint-disable-next-line no-undef
        if (
          dataType === PGDataType.ApplePay ||
          dataType === PGDataType.GooglePay
        ) {
          const executedMethod = wallet.data?.executedMethod;

          // If executedMethod is available, it must match the dataType
          if (executedMethod !== undefined && executedMethod !== null) {
            // eslint-disable-next-line no-undef
            if (dataType === PGDataType.ApplePay && executedMethod !== 4) {
              return false;
            }
            // eslint-disable-next-line no-undef
            if (dataType === PGDataType.GooglePay && executedMethod !== 3) {
              return false;
            }
          }
        }

        return true;
      })
    : [];

  return (
    <form className="credit-card-form" onSubmit={handleSubmitWallet}>
      <label>{"Select from saved digital wallets"}</label>
      <div id="saved_wallets_container">
        {filteredWallets.length === 0 ? (
          <div className="empty-state">
            No digital wallets available for withdrawal
          </div>
        ) : (
          filteredWallets
            .sort((a, b) => {
              if (!a.lastUsed && !b.lastUsed) return 0;
              if (!a.lastUsed) return 1;
              if (!b.lastUsed) return -1;
              return (
                new Date(b.lastUsed).getTime() - new Date(a.lastUsed).getTime()
              );
            })
            .map((wallet, index) => (
              <div className="saved-wallet-row" key={index}>
                <input
                  type="radio"
                  id={`wallet_${wallet.walletReference}`}
                  name="wallet"
                  value={wallet.walletReference}
                  checked={
                    walletData.wallet &&
                    walletData.wallet.walletReference === wallet.walletReference
                  }
                  onChange={() =>
                    handleWalletDataChange({
                      target: { name: "wallet", value: wallet }
                    })
                  }
                />
                <label htmlFor={`wallet_${wallet.walletReference}`}>
                  {`${wallet.providerId} - ${wallet.walletId} (${wallet.walletReference})`}
                </label>
              </div>
            ))
        )}
      </div>
      <button
        className="primary-action"
        type="submit"
        disabled={filteredWallets.length === 0}
      >
        Withdraw
      </button>
    </form>
  );
}

export default WithdrawalDigitalWalletForm;
